// Module
var code = "<react-component name=\"AllAttendancesReport\"></react-component>\n";
// Exports
module.exports = code;